import React from "react";
import styles from "./SearchFilters.module.css";
import { Stack } from "@bookingcom/bui-react";
import { StopsFilterMobile } from "./FiltersSplit/StopsFilter/index.js";
import { AirlinesFilterMobile } from "./FiltersSplit/AirlinesFilter/index.js";
import { FlightTimesFilterMobile } from "./FiltersSplit/FlightTimesFilter/index.js";
import { DurationFilter } from "./FiltersSplit/DurationFilter/index.js";
import { useGetAvailableFilters } from "../SearchResults/components/boundsFilterHooks.js";
import { useSelector } from "react-redux";
import { getSearchResultsVisibleIndexes } from "../../../store/searchResults/selectors.js";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
import AirportsFilter from "./FiltersSplit/AirportsFilter/AirportsFilter.js";
import { AppliedFilterChipsList } from "./FiltersSplit/AppliedFiltersChipsList.js";
import { BudgetPerAdultFilter } from "./FiltersSplit/BudgetPerAdultFilter/BudgetPerAdultFilter.js";
import { LayoverDurationFilter } from "./FiltersSplit/LayoverDurationFilter/LayoverDurationFilter.js";
const SearchFiltersMobile = () => {
    const availableFilters = useGetAvailableFilters();
    const searchResultsVisibleIndexes = useSelector(getSearchResultsVisibleIndexes);
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    return (React.createElement("div", { className: styles.contentWrapper, id: "search_filters_content_wrapper" }, !searchResultsVisibleIndexes && Object.keys(availableFilters).length > 0 ? (React.createElement(Stack, { gap: trackLayoverPriceAirportFilterWeb() ? 4 : 8 },
        React.createElement(StopsFilterMobile, null),
        React.createElement(AirlinesFilterMobile, null),
        React.createElement(FlightTimesFilterMobile, null),
        React.createElement(Stack, { gap: 0 },
            React.createElement(DurationFilter, null),
            trackLayoverPriceAirportFilterWeb() ? React.createElement(LayoverDurationFilter, null) : undefined),
        trackLayoverPriceAirportFilterWeb() ? (React.createElement(React.Fragment, null,
            React.createElement(BudgetPerAdultFilter, null),
            React.createElement(AirportsFilter, null))) : undefined,
        React.createElement(AppliedFilterChipsList, null))) : null));
};
export default SearchFiltersMobile;
